export const ADD_TO_CART_REQUEST_PATH = '/cartapi/api/v2/cart/items';
export const ADD_TO_CART_REFRESH_REQUEST_PATH = '/cartapi/v1/item/add/refresh';
export const CART_LITE_API = '/cartapi/v1/cart/refresh/lite';
